export const creditnotes = {
  breadcrumb: {
    overview: "Creditnota's",
    create: 'Creditnota aanmaken',
  },
  alerts: {
    missingFcFiles_one: 'De PDF voor deze creditnota kan niet worden teruggevonden.',
    missingFcFiles_other: "De PDF's voor deze creditnota's kunnen niet worden teruggevonden.",
    successCreated: 'De creditnota werd succesvol aangemaakt!',
  },
  create: {
    blocker: 'Ben je zeker dat je de pagina wilt verlaten? Je creditnota is nog niet aangemaakt, en alle aanpassingen gaan verloren.',
    confirmation: {
      description:
        'Ben je zeker dat je de creditnota wilt aanmaken? Wanneer de creditnota goedgekeurd en doorgestuurd is, kan je geen aanpassingen meer doen.',
      sentWithPeppol: 'Je creditnota zal na goedkeuring via Peppol verzonden worden.',
      submit: 'Ja, maak creditnota',
      title: 'Je creditnota wordt doorgestuurd',
    },
    error: {
      title: 'Fout bij het laden van het creditnota formulier',
    },
    partialPaymentsWarning: {
      message_one: 'Voor deze factuur hebben wij al een gedeeltelijke betaling van {{ payment }} ontvangen.',
      message_other: 'Voor deze factuur hebben wij al gedeeltelijke betalingen van {{ payment }} ontvangen.',
      title: 'Let op',
    },
    submit: 'Versturen',
    title: 'Creditnota details',
  },
  fields: {
    invoiceId: {
      label: 'Creditnota voor factuur',
      placeholder: 'Selecteer een factuur',
    },
    numberingSeriesId: {
      helpText: 'Het creditnotanummer zal <0>{{entryNumber}}</0> zijn.',
      tooltip: 'Dit is een preview van je creditnotanummer. Je nummer zelf is pas definitief als je de factuur naar ons verstuurt.',
    },
    reason: {
      helpText: 'Dit zal zichtbaar zijn voor jouw klant op de creditnota.',
      label: 'Reden',
      placeholder: 'Vul hier je reden in.',
    },
  },
  overview: {
    columns: {
      client: 'Klant',
      date: 'Datum',
      entryNumber: 'Creditnota',
      reason: 'Reden',
      status: {
        options: {
          Approved: 'Goedgekeurd',
          InReview: 'Ter goedkeuring',
        },
        sentWithPeppolTooltip: 'Verzonden via Peppol',
        title: 'Status',
      },
      total: 'Gecrediteerd',
    },
    created: {
      subtitle: "Creditnota's",
    },
    error: {
      title: "Fout bij het laden van je creditnota's",
    },
    rowActions: {
      download: 'Download',
    },
  },
};
